import React from 'react';
import { QuizGame } from './components/QuizGame';
export function App() {
  return <QuizGame data-id="element-0" />;
}